<template>
  <div class="branches_table loading_table grey">
    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
    <b-table
      default-sort="surname"
      ref="table"
      pagination-simple
      per-page="15"
      :data="filteredUsersList"
      paginated
      checkable
      :checked-rows.sync="rows.checked"
      @page-change="changePage"
      @sort="initSort"
      backend-sorting
      backend-pagination
      :total="totalCount"
      detailed
      :show-detail-icon="false"
      @click="openInfo"
    >
      <template slot-scope="props">
        <b-table-column label="ФИО" :visible="true" field="surname" :centered="false" sortable width="30%">
          <div>{{ props.row.surname }} {{ props.row.name }} {{ props.row.patronymic }}</div>
        </b-table-column>
        <b-table-column label="Роль" :visible="true" field="role" :centered="false" width="15%">
          <div>{{ props.row.role }}</div>
        </b-table-column>
        <b-table-column label="Филиал" :visible="true" field="branches" :centered="false" sortable width="20%">
          <div>{{ props.row.branch.name }}</div>
        </b-table-column>
        <b-table-column
          label="Зарегистрирован"
          :visible="true"
          field="created_at"
          :centered="false"
          sortable
          width="15%"
        >
          <div>{{ props.row.created_at | moment('DD.MM.YYYY') }}</div>
        </b-table-column>
        <b-table-column label="Логин" :visible="true" field="email" :centered="false" sortable width="15%">
          <div>{{ props.row.email }}</div>
        </b-table-column>
      </template>
      <template slot="detail" slot-scope="props">
        <div class="table_actions">
          <button class="delete_course" @click="$emit('delete-user', props.row.id)" v-if="!props.row.deleted_at">
            <i class="mdi mdi-account-remove-outline"></i> В архив
          </button>
          <button class="restore_course" @click="$emit('restore', props.row.id)" v-else>
            <i class="mdi mdi-account-check-outline"></i> Восстановить
          </button>
          <button class="double_course" v-if="!props.row.deleted_at" @click="openUserEdit(props.row)">
            <router-link :to="'/all-users/' + props.row.id">
              <i class="mdi mdi-account-edit"></i> Редактировать/смотреть профиль
            </router-link>
          </button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    usersList: {
      default: () => [],
      type: Array
    },
    rows: {
      default: () => {},
      type: Object
    },
    totalCount: {
      default: () => 0,
      type: Number
    },
    isLoading: {
      default: () => true,
      type: Boolean
    }
  },
  data() {
    return {
      openedRow: {}
    }
  },
  computed: {
    filteredUsersList() {
      this.usersList.forEach((user) => {
        if (!user.roles.length) {
          user.role = '-';
          return;
        }
        user.role = this.$dictionary(user.roles[0].name)
      })
      return this.usersList
    }
  },
  methods: {
    initSort(fieldName, sortType) {
      this.$emit('init-sort', fieldName, sortType)
    },
    openInfo(row) {
      if (row != this.openedRow) {
        this.$refs.table.toggleDetails(this.openedRow)
        this.$refs.table.toggleDetails(row)
        this.openedRow = row
        return
      }
      this.$refs.table.toggleDetails(row)
      this.openedRow = {}
    },
    changePage(val) {
      this.$emit('changePage', val)
    },
    openUserEdit(val) {
      if (this.$browserDetect.isIE) {
        this.$router.push('/all-users/' + val.id)
      }
    }
  }
}
</script>
